import { render, staticRenderFns } from "./deanTableItem.vue?vue&type=template&id=6a318848&scoped=true"
import script from "./deanTableItem.vue?vue&type=script&lang=ts"
export * from "./deanTableItem.vue?vue&type=script&lang=ts"
import style0 from "./deanTableItem.vue?vue&type=style&index=0&id=6a318848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a318848",
  null
  
)

export default component.exports